module.exports = __webpack_public_path__ + "img/dgnb_img.38e8c84d.jpg";